<template>
  <component :is="tag" class="aoformlabel" :class="{'aoformlabel_checkboxmode': checkboxmode, 'aoformlabel_required': required}" :tabindex="-1">
    <span class="aoformlabel__error" v-if="error">{{error}}</span>
    <slot />
    <span v-if="text" class="aoformlabel__text" :class="{'aoformlabel__text_padded':paddedtext}">{{text}}</span>
    <span v-if="checkboxmode" class="aoformlabel__descr" v-html="descr"></span>
  </component >
</template>
<script>
export default {
  props: {
    tag: {type: String, default: 'label'},
    text: {type: String},
    error: {type: String},
    checkboxmode: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    paddedtext: {type: Boolean, default: false},
    descr: {type: String}
  }
}
</script>

<style lang="sass">
.aoformlabel
  display: flex
  flex-direction: column
  justify-content: space-between
  color: colors.$newgray
  font-size: 16px
  line-height: 1
  width: 100%
  height: 58px
  padding-top: 16px
  margin-bottom: 40px
  position: relative
  z-index: 1
  &_halfspace
    margin-bottom: 20px
  &_textarea
    height: 138px !important
    .aoformfield
      height: 100%
      margin: 0
      
  &__datepick-summon-button
    position: absolute
    z-index: 1
    right: 16px
    bottom: 14px
    cursor: pointer
    svg
      display: block
  &__text
    pointer-events: none
    padding-left: 16px
    padding-right: 16px
    order: -1
    display: block
    transition: .3s ease-out
    display: block
    font-size: 16px
    line-height: 17.92px
    color: colors.$newgray
    letter-spacing: globalvars.$onespacing
    transform: translateY(1px)
    max-height: 30px    
    &_padded
      padding-right: 33px
  &_required &__text::after
    content: '*'
    color: colors.$newred
    font-weight: 400
    width: 0
    overflow: visible
    display: inline-block
    transform: translateY(-1px)
  &.filled
    .aoformfield
      border-bottom: 1px solid colors.$newgray
      box-shadow: 0px 2px 0px -1px colors.$newgray
    .aoformlabel__error:not(:empty)~.aoformfield
      border-bottom: 1px solid colors.$newred
      box-shadow: 0px 2px 0px -1px colors.$newred

    .aoformlabel__text
      font-size: 12px
      transform: translateY(-11px)
  .aoformfield:focus ~ .aoformlabel__text
    font-size: 12px
    transform: translateY(-11px)
  .aoformfield
    padding-left: 16px
    padding-right: 16px
    margin-top: -11px
    position: relative
    z-index: -1
    transform: translateY(-3px)
    padding-bottom: 3px
    &_datefield
      padding-right: 56px

  outline: none
  &:focus-visible
    outline: auto
  &_checkboxmode
    border: none !important
    display: flex
    align-items: flex-start
  @include for-mob
    margin-bottom: 32px
    height: 56px
    &_halfspace
      margin-bottom: 16px

  &__descr
    margin-left: 16px
    font-weight: 300
    font-size: 14px
    line-height: 24px

  &:focus-within, &.filled
    border-color: colors.$newgray
  &:focus:not(:focus-visible)
    outline: none
  &:focus-within
    position: relative
    z-index: 3
    .aoformfield_witharrow svg
      transform: rotateX(180deg)
  &:focus-within .aoformdroplist
    pointer-events: auto
    opacity: 1
  &:not(:focus-within) .aoformdroplist
    transition: pointer-events .05s, opacity .05s
  &__error
    position: absolute
    white-space: nowrap
    top: calc(100% + 10px)
    left: 0
    font-size: 14px
    line-height: 1.16
    letter-spacing: globalvars.$onespacing
    color: colors.$red

</style>